require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

/*!
 * pascalcase <https://github.com/jonschlinkert/pascalcase>
 *
 * Copyright (c) 2015-present, Jon ("Schlink") Schlinkert.
 * Licensed under the MIT License.
 */
var titlecase = function titlecase(input) {
  return input[0].toLocaleUpperCase() + input.slice(1);
};

module.exports = function (value) {
  if (value === null || value === void 0) return '';
  if (typeof value.toString !== 'function') return '';
  var input = value.toString().trim();
  if (input === '') return '';
  if (input.length === 1) return input.toLocaleUpperCase();
  var match = input.match(/[a-zA-Z0-9]+/g);

  if (match) {
    return match.map(function (m) {
      return titlecase(m);
    }).join('');
  }

  return input;
};